import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { addOrUpdatePrompt, getPrompt } from '../../../../utils/addPrompt';
import './AddPrompt.scss';

const getBotIDFromURL = () => {
    const urlParts = window.location.href.split('/');
    return urlParts[urlParts.length - 1];
};

export const AddPrompt: React.FC = () => {
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const botID = getBotIDFromURL();

    useEffect(() => {
        if (!botID) return;

        const fetchPrompt = async () => {
            setLoading(true);
            try {
                const existingPrompt = await getPrompt(botID);
                setPrompt(existingPrompt);
            } catch (error) {
                console.error('Failed to load prompt:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPrompt();
    }, [botID]);

    const handleSavePrompt = async () => {
        if (!prompt.trim()) {
            Swal.fire('Empty Prompt', 'Please enter a prompt before saving.', 'warning');
            return;
        }

        setLoading(true);

        try {
            await addOrUpdatePrompt(botID, prompt);

            Swal.fire({
                icon: 'success',
                title: 'Prompt Saved Successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error: any) {
            console.error('Error saving prompt:', error);
            Swal.fire('Error', error.message || 'There was a problem saving the prompt.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='card mb-5 mb-xl-5 p-10'>
            <h4 className='fw-bold text-dark mb-4'>Add New Prompt:</h4>

            <div className='row mb-7'>
                <div className='col-lg-10 fv-row'>
                    <textarea
                        className='form-control form-control-lg'
                        rows={8}
                        value={prompt}
                        placeholder='Enter your prompt here...'
                        onChange={(e) => setPrompt(e.target.value)}
                        disabled={loading}
                    />
                </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-1 px-3'>
                <button
                    type='submit'
                    className='btn btn-primary'
                    onClick={handleSavePrompt}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save Prompt'}
                </button>
            </div>
        </div>
    );
};
